/* settingsSlice.ts */

/* React Toolkit */
import {
  createSlice,
  PayloadAction,
} from "@reduxjs/toolkit";

/* Thunks */
import { fetchBackendSettings } from "src/redux/thunks/settings/backendSettingsThunk";

/* Interfaces */
import {
  BackendSettingsProps,
  DevOptionsProps,
  SettingsProps,
} from "src/shared/interfaces/admin-dashboard/Settings";

const initialState: SettingsProps = {
  devOptions: {
    isDevMode: false,
  },
  backendSettings: {
    careSiteRestrictionEnabled: null,
    status: "idle",
  },
};

export const settingsSlice = createSlice({
  name: "settings",
  initialState: initialState,
  reducers: {
    setDevOptions: (
      state,
      action: PayloadAction<DevOptionsProps>
    ) => {
      state.devOptions = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBackendSettings.pending, (state) => {
        state.backendSettings = {
          careSiteRestrictionEnabled: null,
          status: "loading",
        };
      })
      .addCase(
        fetchBackendSettings.fulfilled,
        (state, action: PayloadAction<BackendSettingsProps>) => {
          state.backendSettings.careSiteRestrictionEnabled =
            action.payload.careSiteRestrictionEnabled;
          state.backendSettings.status = "success";
        }
      )
      .addCase(fetchBackendSettings.rejected, (state) => {
        state.backendSettings.careSiteRestrictionEnabled = null;
        state.backendSettings.status = "error";
      })
      .addMatcher(
        (action) => action.type === "auth/clearAuthState",
        (state) => {
          state.backendSettings = {
            careSiteRestrictionEnabled: null,
            status: "idle",
          };
        }
      );
  },
});

/* Actions */
export const { setDevOptions } = settingsSlice.actions;

/* Reducer */
export default settingsSlice.reducer;
